<template>
  <gg-modal :is-active="isActive" @close="closeModal">
    <template v-slot:toolbar>Delete Email</template>
    <template v-slot:body>
      Are you sure you wish to delete the e-mail {{ email }}? All e-mail and data will be lost forever.
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="closeModal">
        Cancel
      </gg-btn>
      <gg-btn primary :loading="query_loading" @click="removeEmail">
        Delete
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DeleteEmail',
  data: () => ({
    query_loading: false
  }),
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    email: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions({
      deleteEmail: 'email/deleteEmail',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError',
    }),
    async removeEmail () {
      this.query_loading = true

      try {
        await this.deleteEmail(this.email, this.$route.query.user)
        this.query_loading = false
        this.reportSuccess('Email was successfully deleted.')
        this.closeModal()
      } catch (e) {
        this.query_loading = false
        this.reportError(e)
      }
    },

    closeModal () {
      this.$emit('close')
    },

    actionCompleted () {
      this.$emit('action-completed')
    }
  }
}
</script>
